<template>
  <div v-if="stock_detail.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <!-- 明细 -->
      <v-tooltip v-if="showView && $permission.permissionAllow('StockDetails', 'view')" top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  :href="'/#/stock-details/' + stock_detail.id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("Opt.details")]) }}</span>
      </v-tooltip>
      <!-- 冻结 -->
      <v-tooltip
        top
        v-if="
          showProhibit &&
          stock_detail.actions &&
          stock_detail.actions.prohibit &&
          $permission.permissionAllow('StockDetails', 'prohibit')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="accent"
            class="px-2 me-2 mb-1"
            @click.stop="checkActions('cancelProhibit')"
          >
            <v-icon x-small class="pe-1">fa-stamp</v-icon>
            {{ $t("StockDetails.actions.prohibit") }}
          </v-btn>
        </template>
        <span>{{ $t("StockDetails.actions.prohibit") }}</span>
      </v-tooltip>
      <!-- 解冻 -->
      <v-tooltip
        top
        v-if="
          showUnProhibit &&
          stock_detail.actions &&
          stock_detail.actions.un_prohibit &&
          $permission.permissionAllow('StockDetails', 'unProhibit')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small 
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="checkActions('cancelUnProhibit')"
          >
            <v-icon x-small class="pe-1">fa-stamp</v-icon>
            {{ $t("StockDetails.actions.un_prohibit") }}
          </v-btn>
        </template>
        <span>{{ $t("StockDetails.actions.un_prohibit") }}</span>
      </v-tooltip>
      <v-tooltip
              top
              v-if="
          showLoss &&
          stock_detail.actions &&
          stock_detail.actions.loss &&
          $permission.permissionAllow('StockDetails', 'loss')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="danger"
                  class="px-2 me-2 mb-1"
                  @click.stop="checkActions('loss')"
          >
            <v-icon x-small class="pe-1">fa-stamp</v-icon>
            {{ $t("StockDetails.actions.loss") }}
          </v-btn>
        </template>
        <span>{{ $t("StockDetails.actions.loss") }}</span>
      </v-tooltip>
    </v-sheet>
    <DialogProhibit
      v-model="cancelProhibit"
      cancel-mode
      :label="$t('StockDetails.ObjectName')"
      :code="stock_detail.stock_batch_code"
      @confirm="
        doAction('prohibit');
        cancelProhibit = false;
      "
    />
    <!-- UnProhibit -->
    <DialogUnProhibit
      v-model="cancelUnProhibit"
      cancel-mode
      :label="$t('StockDetails.ObjectName')"
      :code="stock_detail.stock_batch_code"
      @confirm="
        doAction('unProhibit');
        cancelUnProhibit = false;
      "
    />
    <!-- loss -->
    <DialogLoss
            v-model="cancelLoss"
            cancel-mode
            :label="$t('StockDetails.ObjectName')"
            :code="stock_detail.stock_batch_code"
            @confirm="
        doAction('loss');
        cancelLoss = false;
      "
    />
  </div>
</template>

<script>
import StockDetails from "@/api/stock_details";
import DialogProhibit from "@/components/plugins/DialogProhibit";
import DialogUnProhibit from "@/components/plugins/DialogUnProhibit";
import DialogLoss from "@/components/plugins/DialogLoss";
import Shops from "@/api/shops";
import i18n from "@/i18n";

export default {
  name: "StockDetailsActions",

  props: {
    stock_detail: Object,
    // detailMode: Boolean,
    showView: Boolean,
    showProhibit: Boolean,
    showUnProhibit: Boolean,
    showLoss: Boolean,
  },
  components: {
    DialogProhibit,
    DialogUnProhibit,
    DialogLoss,
  },
  data: () => ({
    cancelLoss: false,
    cancelProhibit: false,
    cancelUnProhibit: false,
  }),

  methods: {
    actionMethod(mode) {
      if (mode == "prohibit")
        return StockDetails.prohibit(this.stock_detail.id);
      if (mode == "unProhibit")
        return StockDetails.unProhibit(this.stock_detail.id);
      if (mode == "loss")
        return StockDetails.loss(this.stock_detail.id);
    },
    // 冻结 / 解冻 / 报损
    doAction(mode) {
      this.actionMethod(mode).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$emit("done");
          }
        }.bind(this)
      );
    },
    checkActions(mode) {
      Shops.checkAction(4).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.data.actions) {
              if (mode == "cancelUnProhibit") {
                this.cancelUnProhibit = true;
              } else if (mode == "cancelProhibit") {
                this.cancelProhibit = true;
              } else if (mode == "loss") {
                this.cancelLoss = true;
              }
            } else {
              this.$snackbar.error(i18n.t(response.data.data.msg));
            }
          }
        }.bind(this)
      );
    },
  },
};
</script>